module.exports = __webpack_public_path__ + "static/media/desk2.bf8007bf.jpg";